import React from 'react';

import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import {
  getOrCreateGlobalContext,
  useContextWithValidation,
} from '@adsk/alloy-react-context';
import { useLocalState } from '@adsk/alloy-react-helpers';

type SideNavigationProps = {
  collapsed?: boolean;
  setCollapsed: (
    value:
      | boolean
      | undefined
      | ((val: boolean | undefined) => boolean | undefined),
  ) => void;
};

const SideNavigationContext = getOrCreateGlobalContext<SideNavigationProps>(
  CONTEXT_NAMES.SideNavigationContext,
);

export const useSideNavigation = (): SideNavigationProps =>
  useContextWithValidation<SideNavigationProps>(SideNavigationContext, {
    hook: 'useSideNavigation',
    provider: 'SideNavigationProvider',
  });

const STORAGE_KEY = 'ACC_SIDE_NAVIGATION_LOCAL_STORAGE_KEY';

type SideNavigationProviderProps = {
  children: React.ReactNode;
};

export const SideNavigationProvider = ({
  children,
}: SideNavigationProviderProps) => {
  const [collapsed, setCollapsed] = useLocalState<boolean | undefined>(
    STORAGE_KEY,
    false,
  );

  return (
    <SideNavigationContext.Provider value={{ collapsed, setCollapsed }}>
      {children}
    </SideNavigationContext.Provider>
  );
};

SideNavigationProvider.displayName = 'SideNavigationProvider';
